import React from 'react';
import { Button } from './ui/button';
import { Calendar, ArrowRight } from 'lucide-react';
import { heroData, clinicInfo } from '../mockData';

export const Hero = () => {
  const handleBookNow = () => {
    window.open(clinicInfo.bookingUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-48">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="Howick Podiatry - Heidi Barton"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center top' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/95 via-teal-800/85 to-teal-900/40"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="space-y-6 animate-fade-in">
            {/* Badge */}
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
              <div className="w-2 h-2 bg-teal-400 rounded-full animate-pulse"></div>
              <span className="text-white text-sm font-medium">Now Accepting New Patients</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Expert Care for{' '}
              <span className="text-teal-300 italic">Every Step</span>
            </h1>

            {/* Subtitle */}
            <p className="text-xl md:text-2xl text-teal-100 font-light leading-relaxed">
              {heroData.subtitle}
            </p>

            {/* Description */}
            <p className="text-lg text-teal-50 leading-relaxed max-w-2xl">
              {heroData.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={handleBookNow}
                className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
              >
                <Calendar className="w-5 h-5 mr-2" />
                {heroData.ctaText}
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.querySelector('#services');
                  if (element) {
                    const offset = 100;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                  }
                }}
                variant="outline"
                className="bg-white/10 backdrop-blur-sm border-2 border-white hover:bg-white hover:text-teal-700 text-white px-8 py-6 text-lg rounded-full transition-all duration-300"
              >
                Our Services
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
